<template>
  <b-container class="mt-5 text-center">
    <div v-if="communities">
      <div v-if="communities.length === 0">
        <b-alert
          show
          variant="info"
        >
          <p>コミュニティはありません。</p>
          コミュニティを作ってからイベントを作ってみましょう！
        </b-alert>
      </div>
      <div class="justify-content-center">
        <b-row class="justify-content-center">
          <b-col
            v-for="item in communities"
            :key="item.id"
            cols="12"
            sm="9"
            class="community-item"
            :class="item.isActive ?'active' :'passive'"
          >
            <b-link
              class="card mb-5"
              :to="{name: 'community-detail', params: {id: item.id}}"
            >
              <div class="card-image">
                <img
                  :src="getImage(item)"
                  class="card-img-top"
                >
              </div>
              <div class="card-body">
                <div class="status">
                  <b-badge
                    v-if="item.isActive"
                    :variant="badgeStatus[item.status]"
                  >
                    {{ badgeText[item.status] }}
                  </b-badge>
                  <b-badge
                    v-else
                    :variant="badgeStatus[item.status]"
                  >
                    Not Actived
                  </b-badge>
                </div>
                <h4 class="card-title">
                  {{ item.title }}
                </h4>
                <b-card-text>
                  {{ item.description }}
                </b-card-text>
              </div>
            </b-link>
          </b-col>
        </b-row>
      </div>
      <b-row class="justify-content-center mb-5 mt-5">
        <b-col
          cols="12"
          sm="6"
        >
          <b-button
            variant="primary"
            class="mt-2"
            block
            size="lg"
            :to="{name: 'community-create'}"
          >
            コミュニティを作成
          </b-button>
        </b-col>
      </b-row>
    </div>
    <Loader v-if="communityStatus === 'loading'" />
  </b-container>
</template>

<script>
import {COMMUNITY_REQUEST, SET_COMMUNITY_DETAIL} from "@/store/constant";
import {mapGetters} from "vuex";
import {getImage} from "@/helpers";
import community from "@/components/mixins/community";
import Loader from "@/components/Loader";

export default {
  name: 'CommunityList',
  components: { Loader },
  mixins: [community],
  computed: {
    ...mapGetters(['communities', 'communityStatus'])
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$store.dispatch(COMMUNITY_REQUEST, this.$route.params.id);
      this.$store.commit(SET_COMMUNITY_DETAIL, null);
    },
    getImage
  }
}
</script>

<style lang="less" scoped>
.community-item {
  &.passive {
    filter: grayscale(1);

    .card-body {
      opacity: 0.25;
    }
  }
}

.card-body {
  position: relative;
}

.status {
  position: absolute;
  bottom: 0;
  right: 5px;
}

@media only screen and (max-width: 576px) {
  .card-text {
    height: 190px;
    overflow: hidden;
  }
}
</style>
